import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// load language files
import translation_nl from '../translations/nl.json';
import translation_fr from '../translations/fr.json';

// define the translations
const resources = {
	nl: {
		translation: translation_nl
	},
	fr: {
		translation: translation_fr
	}
};

// configure i18n module
i18n
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'nl',
		debug: false,
		keySeparator: '.',
		interpolation: {
			escapeValue: true
		},
		react: {
			transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'sup']
		}
});

export default i18n;